'use client';

import { useState } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

// import { isDevEnv } from '@/utils/env';

interface IProps {
    children: React.ReactNode;
}

export default function TanstackQueryProvider({ children }: IProps) {
    const [queryClient] = useState(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        // refetchOnWindowFocus: 窗口focus时会多次请求以更新数据
                        refetchOnWindowFocus: false,
                        // retry: 请求失败时重新请求
                        retry: false,
                    },
                },
            })
    );

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            {/* {isDevEnv && <ReactQueryDevtools initialIsOpen={false} />} */}
        </QueryClientProvider>
    );
}
